import { motion, AnimatePresence } from 'framer-motion'
import { useToastStore, ToastType } from '@/store/toastStore'

const TOAST_STYLES: Record<ToastType, { bg: string; text: string; icon: string }> = {
  warning: {
    bg: 'bg-amber-100',
    text: 'text-amber-800',
    icon: '!',
  },
  info: {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    icon: 'i',
  },
  success: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    icon: '\u2713',
  },
  error: {
    bg: 'bg-red-100',
    text: 'text-red-800',
    icon: '\u2717',
  },
}

export function ToastContainer() {
  const { toasts, dismissToast } = useToastStore()

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-4 left-4 right-4 z-[100] pointer-events-none flex flex-col items-center gap-2"
    >
      <AnimatePresence mode="popLayout">
        {toasts.map((toast) => {
          const style = TOAST_STYLES[toast.type]
          return (
            <motion.div
              key={toast.id}
              initial={{ opacity: 0, y: -20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -10, scale: 0.95 }}
              transition={{ type: 'spring', damping: 25, stiffness: 300 }}
              onClick={() => dismissToast(toast.id)}
              className={`pointer-events-auto max-w-md w-full ${style.bg} rounded-xl px-4 py-3 shadow-lg cursor-pointer flex items-center gap-3`}
            >
              <div className={`w-6 h-6 rounded-full ${style.text} bg-white/80 flex items-center justify-center font-bold text-sm flex-shrink-0`}>
                {style.icon}
              </div>
              <p className={`${style.text} text-sm font-medium flex-1`}>
                {toast.message}
              </p>
              <svg
                className={`w-4 h-4 ${style.text} opacity-50 flex-shrink-0`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </motion.div>
          )
        })}
      </AnimatePresence>
    </div>
  )
}
